<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
    ></search-form>
    <a-modal
      width="700px"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model no-pdModal"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :editData="editData"
        :disabled="true"
        :data="tableData"
        :idField="idField"
      ></action>
      <approval_process_content :data="approvalProcessData">
      </approval_process_content>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{ x: 'max-content' }"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'transport_type'">
          {{ ['', '取货','送货'][record.transport_type] }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record?.visit_begin_time }} 至
          {{ record?.visit_end_time }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record?.visit_area, Enum.areaType.value) }}
        </template>
        <template v-if="column.key === 'visitor_type'">
          {{ codeToText(record?.visitor_type, Enum.personVisitType.value) }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{ codeToText(record.interviewee_depart_id, Enum.dept.value) }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record?.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{ codeToText(record.create_user_id, Enum.user.value) }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record[idField] + 'detail'"
            >
              详情
            </a-button>
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record[idField] + 'process'"
              v-if="record.state !== 0"
            >
              审批流程
            </a-button>
            <a-button
              @click="showRevokeModal(record)"
              v-if="ableRevoke && (record.state === 1 || record.state === 2)"
              :loading="loadingRecord === record[idField] + 'revoke'"
            >撤销审批</a-button>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>

    <a-modal v-model:open="revokeModalOpen" title="是否撤销审批？">
      <a-form :model="revokeModalData" ref="revokeModalFormRef" :rules="revokeModalRules">
        <a-form-item label="撤销理由" name="reason">
          <a-textarea v-model:value="revokeModalData.reason" placeholder="请输入撤销理由" />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="revokeModalOpen = false">取消</a-button>
        <a-button type="primary" @click="revoke">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    getDetail,
  } from '@/api/transport/all_transport_history'
  import { approvalProcess } from '@/api/transport/all_transport_history'
  import { revokeForAllHis } from '@/api/transport/transport_history'
  import action from './action'
  import searchForm from '@/components/search_form'
  import { codeToText } from '@/utils/format'
  import dayjs from 'dayjs'
  import { message } from 'ant-design-vue'
  import approval_process from '@/components/approval_process'
  import approval_process_content from '@/components/approval_process_content'

  //初始化
  const pageName = '运输运单审批'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const permissionList = computed(() => store.getters['user/permissionList'])
  const Enum = toRefs(store.state.common)
  const ableSearch = computed(() =>
    // !!permissionList.value?.find(item => item.code === 'allTransportListHis:list')
    true
  )
  const ableRevoke = computed(() =>
    !!permissionList.value?.find(item => item.code === 'allTransportListHis:revoke')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'application_number',
      label: '受理单号',
    },
    {
      type: 'input',
      field: 'license_plate',
      label: '申请人证件号码',
      width: '110px',
    },
    {
      type: 'select',
      field: 'transport_type',
      options: [
        {
          label: '取货',
          value: 1
        },
        {
          label: '送货',
          value: 2
        }
      ],
      label: '运货类型',
      width: '140px',
      'allowClear': true
    },
    {
      type: 'input',
      field: 'unified_social_credit_code',
      label: '承运方统一信用代码',
    },
    {
      type: 'input',
      field: 'driver',
      label: '驾驶员姓名',
    },
    {
      type: 'input',
      field: 'supercargo',
      label: '押运员姓名',
    },
    {
      type: 'input',
      field: 'shipper',
      label: '托运人姓名',
    },
    {
      type: 'select',
      field: 'state',
      storeOptions: 'status',
      label: '审批状态',
      width: '130px',
      'allow-clear': true,
    },
    {
      type: 'dateRange',
      startField: 'shipment_date_start',
      endField: 'shipment_date_end',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '起运日期范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setAllPerAppliceHistory', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '受理单号',
      dataIndex: 'application_number',
      key: 'application_number',
      align: 'left',
    },
    {
      title: '被访机构',
      dataIndex: 'name',
      key: 'name',
      dataInObject: 'intervieweeDepart',
      align: 'left',
    },
    {
      title: '运货类型',
      dataIndex: 'transport_type',
      key: 'transport_type',
      align: 'left',
      width: 80,
    },
    {
      title: '运单编号（国家统一运单编号）',
      key: 'list_number',
      dataIndex: 'list_number',
      align: 'left',
    },
    {
      title: '货物名称',
      key: 'cargo_name',
      dataIndex: 'cargo_name',
      align: 'left',
    },
    {
      title: '货物数量',
      dataIndex: 'cargo_quantity',
      key: 'cargo_quantity',
      align: 'left',
    },
    {
      title: '货物单位',
      dataIndex: 'cargo_unit',
      key: 'cargo_unit',
      align: 'left',
    },
    {
      title: '统一信用代码（承运方）',
      dataIndex: 'unified_social_credit_code',
      key: 'unified_social_credit_code',
      align: 'left',
    },
    {
      title: '驾驶员姓名',
      dataIndex: 'driver',
      key: 'driver',
      align: 'left',
    },
    {
      title: '押运员姓名',
      dataIndex: 'supercargo',
      key: 'supercargo',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '托运人姓名',
      dataIndex: 'shipper',
      key: 'shipper',
      align: 'left',
    },
    {
      title: '起运日期',
      dataIndex: 'shipment_date',
      key: 'shipment_date',
      align: 'left',
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
      align: 'left',
    },
    {
      title: '撤销理由',
      dataIndex: 'revoke_reason',
      key: 'revoke_reason',
      align: 'left',
    },
    {
      title: '目的地(省/市/区+详细地址)',
      dataIndex: 'destination',
      key: 'destination',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      // width: '230px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchAllPerAppliceHistory)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、详情
  const open = ref(false)
  const editData = ref(null)
  const showEditModal = async (data) => {
    loadingRecord.value = data[idField] + 'detail'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      open.value = true
      approvalProcessData.value = []
      // 获取审批流程
      if (data.state !== 0 && data.state !== 4) {
        await getApprovalProcess(data[idField])
      }
    }
  }
  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }
  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showEditModal(record);
      }
    }
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    loadingRecord.value = record[idField] + 'process'
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
    loadingRecord.value = null
  }
  async function revoke() {
    await revokeModalFormRef.value.validate()
    const { id, reason } = revokeModalData.value
    loadingRecord.value = id + 'revoke'
    try {
      const res = await revokeForAllHis({ id, reason })
      if (res.success) {
        message.success(res.msg)
        revokeModalOpen.value = false
      }
      fetch()
    } finally {
      loadingRecord.value = null
    }
  }

  const revokeModalFormRef = ref()
  const revokeModalRules = {
    reason: [
      { required: true, message: '请输入撤销理由', trigger: 'blur' }
    ]
  }
  const revokeModalOpen = ref(false)
  const revokeModalData = ref({
    reason: '',
    id: ''
  })
  function showRevokeModal(record) {
    revokeModalData.value = {
      reason: '',
      id: record[idField]
    }
    revokeModalOpen.value = true
  }
</script>
